import { cn } from "@/lib/utils";
import { RagDot, ragLabel } from "@/components/ui/rag";

const RAG_BAR = {
  green: "bg-success",
  amber: "bg-warning",
  red: "bg-destructive",
  na: "bg-border",
  unknown: "bg-muted-foreground"
};

export function ReadyDomainSummary({ domains }) {
  return (
    <section className="paper-card overflow-hidden">
      <div className="flex flex-col gap-1 border-b border-border bg-card/80 px-6 py-4">
        <p className="eyebrow">§ 04 · Framework rollup</p>
        <h3 className="font-display text-lg font-medium text-foreground">R.E.A.D.Y. summary</h3>
        <p className="text-xs leading-relaxed text-muted-foreground">
          Aggregate readiness for each R.E.A.D.Y. domain, derived from the 17-item evidence map.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-px bg-border md:grid-cols-5">
        {domains.map((d) => (
          <div key={d.key} className="flex flex-col gap-3 bg-card p-5">
            <div className="flex items-center gap-3">
              <span className="letter-mark h-8 w-8 text-sm">{d.key}</span>
              <div className="flex min-w-0 flex-col leading-tight">
                <span className="font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                  Domain
                </span>
                <span className="truncate font-display text-sm font-medium text-foreground">
                  {d.title}
                </span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <RagDot rag={d.rag} />
              <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-foreground">
                {ragLabel(d.rag)}
              </span>
            </div>
            <div className="flex h-1.5 w-full overflow-hidden rounded-sm bg-secondary">
              {["green", "amber", "red"].map((key) => {
                const n = d.counts[key] || 0;
                if (n === 0) return null;
                const total = d.considered || 1;
                return (
                  <span
                    key={key}
                    className={cn("block h-full", RAG_BAR[key])}
                    style={{ width: `${(n / total) * 100}%` }}
                  />
                );
              })}
            </div>
            <ul className="grid grid-cols-2 gap-1 text-[11px] text-muted-foreground">
              <li className="flex items-center gap-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-success" />
                <span className="font-mono-label">{d.counts.green || 0} green</span>
              </li>
              <li className="flex items-center gap-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-warning" />
                <span className="font-mono-label">{d.counts.amber || 0} amber</span>
              </li>
              <li className="flex items-center gap-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-destructive" />
                <span className="font-mono-label">{d.counts.red || 0} red</span>
              </li>
              <li className="flex items-center gap-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-border" />
                <span className="font-mono-label">{d.counts.na || 0} n/a</span>
              </li>
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
